export const isActive = (date, numWeeks) => {
  const createdAtDate = new Date(date);
  if (
    createdAtDate.setDate(createdAtDate.getDate() + numWeeks * 7) > new Date()
  ) {
    return true;
  }
  return false;
};

export const getEndDateOfProgram = (date, numWeeks) => {
  const createdAtDate = new Date(date);
  return createdAtDate.setDate(createdAtDate.getDate() + numWeeks * 7);
};

export const programInterval = (param) => {
  switch (param) {
    case "7":
      return "täglich";
    default:
      return param + "mal pro Woche";
  }
};

export const getTargetName = (param) => {
  switch (param) {
    case "1":
      return "Schmerzlinderung";
    case "2":
      return "Kräftigung";
    case "3":
      return "Beweglichkeit";
    case "4":
      return "Koordination";
    case "5":
      return "Prävention";
    case "6":
      return "Entspannung";
    case "7":
      return "Asudauer";
    default:
      return "Schmerzliderung";
  }
};
